import React from "react";
import FilesGroup from "../FilesGroup";
import { useFilesArg } from "../FilesArgContext";
import { Empty } from "antd";

// FilesSeries 组件用于展示文件系列
export default function FilesSeries() {
  const { entries = [], product_category, series_id } = useFilesArg();

  // 如果有文件系列，则依次渲染每个文件组
  return (
    <>
      {entries.length > 0 ? (
        entries.map(item => {
          return (
            <FilesGroup
              key={item.id}
              name={item.name}
              paramsObj={{
                category: item.id,
                product_category,
                series_id,
              }}
            />
          );
        })
      ) : (
        // 如果没有数据，则显示空状态提示
        <Empty description="No Data" />
      )}
    </>
  );
}
